import { Box, Stack } from "@mui/material";
import { Control, useWatch } from "react-hook-form";

import FieldworkerAvailabilityEvent from "../FieldworkerAvailabilityEvent";
import { FieldworkerPlanningFormValues } from "../FieldworkerPlanning";

type Props = {
    control: Control<FieldworkerPlanningFormValues, unknown>;
    dayIndex: number;
};

export default function CalendarDayEvents({ control, dayIndex }: Props) {
    const value = useWatch({ control, name: `elements.${dayIndex}` });

    return (
        <Stack gap={1} mt={1}>
            {value?.availabilities !== undefined && value.availabilities.length > 0 ? (
                value.availabilities.map((availability, index) => (
                    <FieldworkerAvailabilityEvent
                        key={index}
                        availabilityIndex={index}
                        control={control}
                        dayIndex={dayIndex}
                        disabled={availability.disabled}
                        name={availability.name}
                    />
                ))
            ) : (
                <Box
                    sx={{
                        height: 48,
                        width: "100%",
                    }}
                />
            )}
        </Stack>
    );
}
